module.exports = __webpack_public_path__ + "img/overview-course.c7bac783.png";